import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {TipoMarcacao} from "../../../domain/TipoMarcacao";

@Injectable()
export class TipoMarcacaoHttpService  extends AbstractHttpService<TipoMarcacao>{
    url = '/api/tipoMarcacao';
}
